import { AriaAttributes, InputHTMLAttributes, useEffect, useRef } from "react";

type CheckboxProps = AriaAttributes &
  InputHTMLAttributes<HTMLInputElement> & {
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    indeterminate?: boolean;
  };

export function Checkbox(props: CheckboxProps) {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = props.indeterminate ?? false;
    }
  }, [props.indeterminate]);

  return (
    <input
      ref={ref}
      id={props.id}
      aria-describedby={props["aria-describedby"]}
      name={props.name}
      type="checkbox"
      checked={props.checked}
      onClick={(e) => {
        e.stopPropagation();
        props.onClick?.(e);
      }}
      onChange={(e) => {
        props.onChange(e);
      }}
      className="cursor-pointer hover:border-persian-600 h-4 w-4 rounded border-gray-300 text-persian-600 focus:ring-persian-600"
    />
  );
}
